import React from 'react';
import { Field, reduxForm } from 'redux-form';
import AnimatedButton from 'common/components/animated_button';
import { PasswordInputField, DEFAULT_REQUIRED_MESSAGE } from 'common/components/form_fields';
import { validatePwdStrength } from 'common/utils';

const PasswordChangeForm = ({error, handleSubmit, submitting, submitFailed, toggled,
                             onToggle, reset, noConfirmation}) => {

  /* prevent form submission & reset form on (un)toggling */
  const handleToggle = (e) => {
    e.preventDefault()
    reset()
    onToggle()
  }

  return (
    /* using a div here instead of a form because we can't have nested forms... */
    <div className="row password-change">
      {!noConfirmation &&
      <div className='columns small-16 medium-8 large-4'>
        <Field name="old_password" label={(toggled? "Old ":"") + "Password"} disabled={!toggled}
          component={PasswordInputField} defaultValue={toggled? "":"******"}/>
      </div>}

      {(noConfirmation || toggled) &&
      <div className={'columns small-16 medium-8 large-' + (noConfirmation? '8':'4')}>
        <Field name="new_password" label="New Password" component={PasswordInputField}
               showVisibilityToggle={true} indicateStrength={true} />
      </div>}

      <div className={'columns small-16 medium-8 large-' + (noConfirmation? '8':'8')}>
        {(noConfirmation || toggled) &&
        <AnimatedButton
          processing={submitting}
          label="Save Password"
          onClick={handleSubmit}
          processingLabel="Saving..."
          errorMsg={error || submitFailed}
          successMsg="Password Updated!"
        />}

        {!noConfirmation &&
        <button onClick={handleToggle} className="btn btn-secondary btn-block">
          {toggled? "Cancel":"Change"}
        </button>}
      </div>
    </div>)
}

const validate = values => {
  const errors = {}
  const requiredFields = ['old_password', 'new_password']
  for (let f of requiredFields) {
    if (!values[f]) errors[f] = DEFAULT_REQUIRED_MESSAGE
  }
  /* validate new password strength */
  if (!errors['new_password']) {
    errors['new_password'] = validatePwdStrength(values['new_password'])
  }
  return errors
}

export default reduxForm({
  form: "PasswordChangeForm",
  validate,
})(PasswordChangeForm);



// WEBPACK FOOTER //
// ./account/components/change_password_form.jsx